export default __webpack_public_path__ + "static/media/WifiPicture.7f443ec4.png";